/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uGlobeGrid = A4uGlobeGrid;

var _react = _interopRequireDefault(require("react"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function A4uGlobeGrid(_ref) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 'M' : _ref$scale,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'LIGHT' : _ref$color,
      props = _objectWithoutProperties(_ref, ["scale", "color"]);

  return _react["default"].createElement("svg", _extends({
    viewBox: _util.viewBoxes[scale]
  }, props, props), _react["default"].createElement("path", {
    d: "M17 0a17 17 0 1 0 17 17A17 17 0 0 0 17 0zm13.749 16h-5.571a27.12 27.12 0 0 0-.853-6h4.547a13.676 13.676 0 0 1 1.877 6zm-3.311-8H23.7a14.681 14.681 0 0 0-2.2-4.04A13.864 13.864 0 0 1 27.438 8zM16 18v6h-4.268a24.81 24.81 0 0 1-.911-6zm-5.179-2a24.81 24.81 0 0 1 .911-6H16v6zM18 18h5.179a24.81 24.81 0 0 1-.911 6H18zm0-2v-6h4.268a24.81 24.81 0 0 1 .911 6zm3.568-8H18V3.619C19.307 4.158 20.6 5.7 21.568 8zM16 3.619V8h-3.568C13.4 5.7 14.693 4.158 16 3.619zm-3.5.341A14.681 14.681 0 0 0 10.305 8H6.562A13.864 13.864 0 0 1 12.5 3.96zM5.128 10h4.547a27.12 27.12 0 0 0-.853 6H3.251a13.676 13.676 0 0 1 1.877-6zm-1.877 8h5.571a27.12 27.12 0 0 0 .853 6H5.128a13.676 13.676 0 0 1-1.877-6zm3.311 8h3.743a14.681 14.681 0 0 0 2.195 4.04A13.864 13.864 0 0 1 6.562 26zm5.87 0H16v4.381c-1.307-.539-2.6-2.081-3.568-4.381zM18 30.381V26h3.568c-.968 2.3-2.261 3.842-3.568 4.381zm3.5-.341A14.681 14.681 0 0 0 23.7 26h3.743a13.864 13.864 0 0 1-5.943 4.04zM28.872 24h-4.547a27.12 27.12 0 0 0 .853-6h5.571a13.676 13.676 0 0 1-1.877 6z"
  }));
}